

















































import EmbeddedChatConversationPart from '@/components/conversation/EmbeddedChatConversationPart.vue';
import EmbeddedChatConversationQuickReply from '@/components/conversation/EmbeddedChatConversationQuickReply.vue';
import { Conversation } from '@/types';
import {
  Action,
  ActionType,
  ClientEvent,
  QuickReplyAction,
  RequestType,
  SpeechAction,
  SpeechRecognizerEvent,
  SpeechSynthesizerEvent,
  AudioHelper,
  WebRequest,
  WebResponse
} from 'jovo-client-web-vue';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'embedded-chat-conversation',
  components: { EmbeddedChatConversationQuickReply, EmbeddedChatConversationPart },
})
export default class EmbeddedChatConversation extends Vue {
  conversation: Conversation = {
    quickReplies: [],
    parts: [],
  };
  includeOutput = false;
  isHovered = false;

  handleQuickReplyScroll(event: WheelEvent) {
    (this.$refs.quickReplyContainer as HTMLElement).scrollBy({
      left: event.deltaY,
    });
  }

  mounted() {
    window.addEventListener('resize', this.scrollToBottom);
    this.$client.on(ClientEvent.Request, this.onRequest);
    this.$client.on(ClientEvent.Response, this.onResponse);
    this.$client.on(ClientEvent.Reprompt, this.onReprompt);
    this.$client.on(ClientEvent.Action, this.onAction);
    this.$client.on(ClientEvent.RepromptLimitReached, this.onRepromptLimitReached);
    this.$client.$speechRecognizer.on(
      SpeechRecognizerEvent.SpeechRecognized,
      this.onSpeechRecognized,
    );
    this.$client.$speechSynthesizer.on(SpeechSynthesizerEvent.Speak, this.onSpeechSpeak);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.scrollToBottom);
    this.$client.off(ClientEvent.Request, this.onRequest);
    this.$client.off(ClientEvent.Response, this.onResponse);
    this.$client.off(ClientEvent.Reprompt, this.onReprompt);
    this.$client.off(ClientEvent.Action, this.onAction);
    this.$client.off(ClientEvent.RepromptLimitReached, this.onRepromptLimitReached);
    this.$client.$speechRecognizer.off(
      SpeechRecognizerEvent.SpeechRecognized,
      this.onSpeechRecognized,
    );
    this.$client.$speechSynthesizer.on(SpeechSynthesizerEvent.Speak, this.onSpeechSpeak);
  }

  scrollToBottom() {
    const partContainer = this.$refs.partContainer as HTMLDivElement;
    partContainer.scrollTop = partContainer.scrollHeight;
  }

  private onRequest(req: WebRequest) {
    this.includeOutput = true;
    this.conversation.quickReplies = [];
    switch (req.request.type) {
      case RequestType.Text:
      case RequestType.TranscribedText:
        this.conversation.parts.push({
          type: 'request',
          subType: 'text',
          value: req.request.body.text!, // eslint-disable-line
        });
        break;
      case RequestType.Audio:
        this.conversation.parts.push({
          type: 'request',
          subType: 'audio',
          value: req.request.body.audio!.b64string,     // eslint-disable-line
        });
        break;
      default:
        break;
    }
  }

  private onResponse(res: WebResponse) {
/*
    if (res.context.request.asr?.text) {
      this.inputText = res.context.request.asr.text;
    }
*/
  }

  private onReprompt() {
    this.includeOutput = false;
  }

  private onRepromptLimitReached() {
    this.conversation.quickReplies = [];
  }


  private onSpeechRecognized(event: SpeechRecognitionEvent) {
    //console.log("onSpeechRecognized", AudioHelper.textFromSpeechRecognition(event));
//    this.inputText = AudioHelper.textFromSpeechRecognition(event);
  }

  private onSpeechSpeak(utterance: SpeechSynthesisUtterance) {
//    this.outputText = utterance.text;
  }

  private onAction(action: Action) {
  //  console.log("onAction ",action);
    if (!this.includeOutput) return;
    switch (action.type) {
      case ActionType.QuickReply: {
        this.conversation.quickReplies = (action as QuickReplyAction).replies.map((reply) => {
          return reply.value;
        });
        break;
      }
      case ActionType.Speech: {
        const { plain, displayText, ssml } = action as SpeechAction;
        const value =
          displayText || plain || (ssml ? this.$client.$ssmlHandler.removeSSML(ssml) : undefined);
        if (!value) {
          return;
        }
/*
         this.conversation.parts.push({
           type: 'response',
           subType: 'text',
           value,
         });
*/
        for (let index = 0; index < value.split('<nextbubble>').length; index++) {
          const element = value.split('<nextbubble>')[index];
          this.conversation.parts.push({
            type: 'response',
            subType: 'text',
            value: element,
          });
        }
        break;
      }
        default:
          break;
    }
  }

  @Watch('conversation', { deep: true })
  private async onPartsChange() {
    // wait for dom changes
    await this.$nextTick();
    this.scrollToBottom();
  }
}
